import React from 'react'
import Icon from '../misc/Icons'
import SearchResultsRowPath from './SearchResultsRowPath'
import { formatDate } from '../../utils/formatDate'
import { getRepoforId } from '../../utils/getRepoforId'

function LocalBadge({ folder }) {
  if (!folder.__localOrigin) return null
  if (folder.__localEngine === 'minisearch') {
    return <Icon name='local-source-bm25' className='searchResults-localBadge searchResults-localBadge--bm25' />
  }
  return <Icon name='fuse-source' className='searchResults-localBadge' />
}

class SearchResultsFolderCard extends React.Component {
  render() {
    const { folder, onClick, onDoubleClick } = this.props
    let inSharedRepo = false
    let inPublicConsumerRepo = false
    if (folder.repo) {
      const parentRepo = getRepoforId(folder.repo)
      if (parentRepo) {
        inSharedRepo = parentRepo.shared
        inPublicConsumerRepo = parentRepo.role === 'consumer'
      }
    }

    return (
      <div
        className='searchResultsRow searchResultsRow--folder'
        role='button'
        tabIndex={0}
        onClick={onClick}
        onDoubleClick={onDoubleClick}
      >
        <div className='searchResultsRow-icon'>
          <Icon name={!folder.readOnly ? 'folder' : 'folder-isbe'} />
        </div>
        <div className='searchResultsRow-body'>
          <div className='searchResultsRow-title'>
            <span className='searchResultsRow-title-text'>{folder.name}</span>
            {inSharedRepo && <Icon name='shared' />}
            {inPublicConsumerRepo && <Icon name='globe-shared' />}
            <LocalBadge folder={folder} />
          </div>
          <SearchResultsRowPath item={folder} />
          <div className='searchResultsRow-meta'>
            {folder.clientModified && (
              <span className='searchResultsRow-meta-edited'>
                {'Edited '}
                {formatDate(folder.clientModified)}
              </span>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default SearchResultsFolderCard
